module Widgets.Form.Common where

import Common

import Concur.React.DOM as D
import Concur.React.Props (ReactProps)
import Concur.React.Props as P
import Widgets.Form.Class (FormContext, fieldId)

-- | Type for common fields shared by widgets that have labels.
type Labelable r =
    { id :: String
    , label :: String
    | r
    }

-- | Same as labelable but for optional labels.
type MaybeLabelable r =
    { id :: String
    , label :: Maybe String
    | r
    }


-- | Renders a label for a widget with a given ID and label.
-- |
-- | NOTE: **Never call this with user input as the label, as this allows
-- | arbitraty HTML**
widgetLabel :: forall a. String -> String -> Array (ReactProps a) -> Widget HTML a
widgetLabel for label extraProps = D.label
    ([ P.htmlFor for
    , P.dangerouslySetInnerHTML { __html: label }
    ] <> extraProps) []

widgetLabel' :: forall a. String -> String -> Widget HTML a
widgetLabel' for label = widgetLabel for label []

widgetLabelS :: forall a r. FormContext -> Labelable r -> Array (ReactProps a) -> Widget HTML a
widgetLabelS fc { id, label } props = widgetLabel (fieldId fc id) label props

widgetLabelS' :: forall a r. FormContext -> Labelable r -> Widget HTML a
widgetLabelS' fc { id, label } = widgetLabel' (fieldId fc id) label

widgetLabelM :: forall a r. FormContext -> MaybeLabelable r -> Array (ReactProps a) -> Widget HTML a
widgetLabelM fc { id, label: Just label } props = widgetLabel (fieldId fc id) label props
widgetLabelM _ { label: Nothing } _ = D.div' [] -- FIXME: Does concur have a no-op widget?

widgetLabelM' :: forall a r. FormContext -> MaybeLabelable r -> Widget HTML a
widgetLabelM' fc state = widgetLabelM fc state []
